import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./container/Home/Home";
import Error from "./container/Error/Error";
import Unsubscribe from "./container/Unsubscribe/Unsubscribe";
import About from "./container/About/About";
import NavBar from "./container/NavBar/NavBar";
import Footer from "./container/Footer/Footer";

const App = () => {
  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<Error />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
};

export default App;
